import script from "./WPatientDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./WPatientDetail.vue?vue&type=script&lang=ts&setup=true"

import "./WPatientDetail.vue?vue&type=style&index=0&id=55785184&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55785184"]])

export default __exports__